<template>
  <div class="public-attach-com">
    <div class="left">
      <uploadBase
        ref="uploadRef"
        :btnName="'上传新附件'"
        :uploadMethod="'cdEiaEnclosureUpload'"
        :acceptList="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf, .zip, .rar, .7z, .tar'"
        :extaParam="{
          type: this.type,
          eiaStatusId: this.eiaStatusId
        }"
        :fileSize="20"
        overSizeTip="，可以将文件上传到百度云，使用百度云链接"
        @uploadSuccess="handleSuccess"
        @beforeUpload="checkUpload"></uploadBase>
    </div>
    <div v-if="attcahList.length" class="middle"><br>上方上传新材料<br>下方显示已上传</div>
    <div v-if="attcahList.length" class="right">
      <div class="img-wrap" v-for="(item, index) in attcahList" :key="index" @click="selectAttach(item)">
        <img src="https://image.qsyhbgj.com/img-attach.png" alt="">
        <span @click="openIt(item.url)" class="name">{{item.url}}</span>
        <i class="el-icon-close" @click.stop="deleteAttach(item.id, index)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api/indexForCoe'
// import { ipcRenderer } from 'electron'
import uploadBase from '../coe-com/uploadBase'
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    eiaStatusId: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      listLoading: false,
      attcahList: []
    }
  },
  mounted () {
    this.getList()
  },
  activated () {
    this.getList()
  },
  methods: {
    openIt (url) {
      // ipcRenderer.send('ipcDownloadBegin', url)
      window.open(url)
    },
    handleSuccess (url) {
      this.$emit('dispachUrl', url)
      this.getList()
    },
    getList () {
      api.cdEiaEnclosureEnquiry({
        pages: 200,
        pageNo: 1,
        type: this.type,
        eiaStatusId: this.eiaStatusId
      }).then(res => {
        if (res.code === 200) {
          this.attcahList = res.data.list
          // this.attcahList = res.data
        }
      })
    },
    selectAttach (item) {
      this.$emit('dispachUrl', item)
    },
    deleteAttach (id, index) {
      this.listLoading = true
      api.cdEiaEnclosureDelete({
        id: id
      }).then(res => {
        this.listLoading = false
        if (res.code === 200) {
          this.attcahList.splice(index, 1)
        }
      })
    },
    checkUpload () {
      if (this.attcahList.length >= 200) {
        // this.$message({
        //   message: '每个用户最多上传200条材料，请删除一条后再试',
        //   type: 'warning'
        // })
        this.$toast.text('每个用户最多上传200条材料，请删除一条后再试')
        return
      }
      this.$refs.uploadRef.doUpload()
    }
  },
  components: {
    uploadBase
  }
}
</script>

<style lang="scss">
  .public-attach-com {
    // display: flex;
    // justify-content: center;
    // align-items: center;
    .middle {
      flex: 0 0 auto;
      margin: 0 12px;
    }
    .right {
      flex: 1 1 140px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      height: 188px;
      overflow: auto;
      // display: flex;
      flex-wrap: wrap;
      padding: 12px;
      align-items: flex-start;
      .img-wrap {
        margin: 0 6px 2px 0;
        position: relative;
        border: 1px dashed transparent;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        &:hover {
          border-color: #409eff;
        }
        i {
          position: absolute;
          background: #fff;
          border: 1px solid #F56C6C;
          right: -8px;
          top: -8px;
          border-radius: 50%;
          color: #F56C6C;
          cursor: pointer;
        }
        img {
          height: 52px;
          width: 52px;
        }
        .name {
          font-size: 12px;
        }
      }
    }
  }
</style>
